import { useEffect } from "react";
import { useAuthStore } from "../stores/authStore";
import {
  connectEvents,
  onForceLogout,
  disconnectEvents,
} from "../lib/events-client";

const API_URL = (import.meta.env.VITE_API_URL || "http://localhost:5001")
  .replace(/\/$/, "")
  .replace(/\/api\/?$/, "");

/**
 * Hook that connects to the WebSocket server and listens for
 * force-logout events. When received, clears the auth session.
 * Should be mounted once at the app root (e.g., in App.tsx or a layout).
 */
export function useForceLogoutListener() {
  const token = useAuthStore((s) => s.token);
  const logout = useAuthStore((s) => s.logout);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated || !token) {
      return;
    }

    connectEvents(API_URL, token);

    const unsubscribe = onForceLogout(() => {
      void logout();
      window.location.href = "/login?reason=force-logout";
    });

    return () => {
      unsubscribe();
      disconnectEvents();
    };
  }, [isAuthenticated, token, logout]);
}
